/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

const mutations = {
  // input disable khi sửa vai trò
  DISABLED_ROLE(state) {
    state.disabledRole = true;
  },
  // mở disable input role
  UNDISABLED_ROLE(state) {
    state.disabledRole = false;
  },

  // Lấy danh sách merchant của tài khoản
  GET_MERCHANTS(state, payload) {
    state.merchants = payload;
  },

  // Thêm merchant
  ADD_MERCHANTS(state, payload) {
    state.merchants = payload;
  },

  updateRoleLocal(state, payload) {
    const LocalRoleKey = "RoleLocal";
    let RoleLocal = [];
    if (payload) {
      RoleLocal = payload;
      localStorage.setItem(LocalRoleKey, JSON.stringify(payload));
    }
    state.RoleLocal = { ...state.RoleLocal, ...RoleLocal };
  },

  //Các hàm phục vụ cho thu hộ doanh nghiệp
  setCustomersList(state, value) {
    state.cboCustomers = value;
  },

  setItemCustomersList(state, value) {
    state.cboCustomers.append(value);
  },

  setCurrentPeriod(state, value) {
    state.currentPeriod = value;
  },
  setRangeDate(state, value) {
    state.fromDate = value.fromDate;
    state.toDate = value.toDate;
  },
};

export default mutations;
